@use '@lib/assets/styles/main.scss' as *;

.root {
  margin-bottom: 16px;
}
